import trackEvent from '../../helpers/gtm/eventPush';
import getCurrentDateTime from './getCurrentDateTime';

// Function to track basic_profile_form_show
const trackBasicProfileShow = function() {
  const time = getCurrentDateTime();
  const fields = [
    'advertiser_role',
    'date_available',
    'min_term',
    'max_term',
    'gender',
    'dob',
    'occupation',
    'profile_photo',
  ];

  const fieldsShown = [];

  // Delay to allow form to render
  setTimeout(() => {
    const form = document.querySelector('.profile-form');

    if (!form) {
      return;
    }

    fields.forEach((field) => {
      const element = form.querySelector(`[name="${field}"]`);
      if (element) {
        fieldsShown.push(field);
      }
    });

    if (form.querySelector('#basicProfileDob')) {
      fieldsShown.push('dob');
    }

    if (form.querySelector('.form-group--photo [type="button"]')) {
      fieldsShown.push('profile_photo');
    }

    const label = [].concat(...fieldsShown);

    trackEvent({
      category: 'profile',
      action: `basic_profile_form_show`,
      label: `fields_shown=${label}|time=${time}`,
    });
  }, 100);
};

// Function to track basic_profile_form_submit
const trackBasicProfileSubmit = function(initialData, savedData) {
  const time = getCurrentDateTime();
  const diffFields = findDifferences(initialData, savedData);
  const yearFields = ['day', 'month', 'year'];

  // Check if dob has been updated
  const dobInitial = initialData?.split_date_of_birth;
  const dobSaved = savedData?.split_date_of_birth;
  if (dobSaved && dobSaved.day && dobSaved.month && dobSaved.year) {
    if (JSON.stringify(dobInitial) !== JSON.stringify(dobSaved)) {
      diffFields.push('dob');
    }
  }

  // Remove split dob fields
  yearFields.push('split_date_of_birth');
  const changedFields = diffFields.filter(
    (string) => !yearFields.includes(string),
  );

  // Check if profile photo has been updated
  const checkPhoto = document.querySelector('#profilePhoto');
  if (checkPhoto && checkPhoto.classList.contains('photo-updated')) {
    changedFields.push('profile_photo');
  }

  const label = changedFields.join(',');

  trackEvent({
    category: 'profile',
    action: `basic_profile_form_submit`,
    label: `fields_changed=${label}|time=${time}`,
  });
};

// Function to track basic_profile_form_skip
const trackBasicProfileSkip = function() {
  trackEvent({
    category: 'profile',
    action: 'basic_profile_form_skip',
    label: '',
  });
};

// Function find the difference between two profile objects
const findDifferences = function(obj1, obj2) {
  const changedKeys = [];

  function extractLastKey(path) {
    const parts = path.split('.');
    return parts[parts.length - 1];
  }

  function compareProps(o1, o2, path) {
    if (
      o1 === null ||
      o2 === null ||
      typeof o1 !== 'object' ||
      typeof o2 !== 'object'
    ) {
      if (o1 !== o2) {
        changedKeys.push(extractLastKey(path));
      }
      return;
    }

    const keys1 = Object.keys(o1);
    const keys2 = Object.keys(o2);

    const allKeys = [...new Set([...keys1, ...keys2])];

    allKeys.forEach((key) => {
      const val1 = o1[key];
      const val2 = o2[key];
      const currentPath = path ? `${path}.${key}` : key;

      if (typeof val1 === 'object' || typeof val2 === 'object') {
        compareProps(val1, val2, currentPath);
      } else if (val1 !== val2) {
        changedKeys.push(extractLastKey(currentPath));
      }
    });
  }

  compareProps(obj1, obj2, '');

  return changedKeys;
};

export {
  trackBasicProfileShow,
  trackBasicProfileSubmit,
  trackBasicProfileSkip,
};
